var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, OnInit, OnDestroy /*, OnChanges */ } from '@angular/core';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { AirportInputComponent } from './airport-input.component';
import { takeWhile } from 'rxjs/operators';
var INDRAAirportInputComponent = /** @class */ (function (_super) {
    __extends(INDRAAirportInputComponent, _super);
    function INDRAAirportInputComponent(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.query = _this.airport !== null ? _this.airport : '';
        _this.label_key = null;
        _this.label_filled_key = null;
        _this.isLoading = false;
        _this.completeOptions = [];
        _this.disabledForm = false;
        _this.instruction = false;
        _this.placeholder = 'flightStatus.label.countryCityAirport';
        _this.instructionKey = null;
        _this.ariaDescribedby = null;
        _this.isTripFinder = false;
        _this.showLastSearch = true;
        _this.dataOptions = []; // select options
        _this.selected = new EventEmitter();
        // @Input()
        // showRecentSearch = true;
        _this.hasFocus = false;
        _this.showAutocomplete = false;
        _this.searchRoutes$ = _this.store.select(fromStore.getMiniIBESearchRoutes);
        _this.currentSearch$ = _this.store.select(fromStore.getMiniIBECurrentSeachRoute);
        _this.isAlive = true;
        _this.keyboardInput = '';
        _this.autocompleteFocusedID = null;
        // isDisabled = true; // added to disabled input
        // required for ControlValueAccessor
        _this.propagateChange = function (_) { };
        _this.currentSearch$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) { return _this.currentSearch = value; });
        _this.searchRoutes$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.searchRoutes = value;
        });
        return _this;
    }
    INDRAAirportInputComponent.prototype.ngOnInit = function () { };
    INDRAAirportInputComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    Object.defineProperty(INDRAAirportInputComponent.prototype, "INDRA_printAirportName", {
        /**
         * Print airport name on input
         */
        get: function () {
            if (this.airport && this.airport.location) {
                var airport = this.airport;
                // Check if airport name is diferent then city name
                // const airportName = airport.location.city.toLowerCase() === airport.name.toLowerCase() ? '' : airport.name + ', ';
                // return (
                // 	airport.location.city + ', ' + airportName + airport.location.country
                // );
                return (airport.location.city + ', ' + airport.location.country);
            }
            if (this.airport && this.airport['type']) {
                return this.airport['value'].label;
            }
            return this.keyboardInput;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Print airport iata code on input
     */
    INDRAAirportInputComponent.prototype.INDRA_printAirportCode = function () {
        if (this.airport && this.airport.location) {
            var airport = this.airport;
            return airport.code;
        }
        if (this.airport && this.airport['type']) {
            return this.airport['value'].icon;
        }
        return '';
    };
    // Returns whether form control (gotten by key) has a value;
    INDRAAirportInputComponent.prototype.INDRA_printLabel = function () {
        return !this.airport ? this.label : this.label_filled;
    };
    INDRAAirportInputComponent.prototype.INDRA_getLabelKey = function () {
        return !this.airport ? this.label_key : this.label_filled_key;
    };
    INDRAAirportInputComponent.prototype.INDRA_handleInputChange = function (e) {
        if (this.airport) {
            var diff = function (diffMe, diffBy) { return diffMe.split(diffBy).join(''); };
            this.keyboardInput = diff(e.target.value, this.airport.location.city + ', ' + this.airport.location.country);
        }
        this.airport = null;
        this.hasFocus = true;
        this.showAutocomplete = true;
        this.query = e.target.value;
        this.propagateChange(e.target.value);
    };
    INDRAAirportInputComponent.prototype.INDRA_handleInputFocus = function (e) {
        this.store.dispatch(new MiniIBEActions.PutActiveInput(this.label_filled.toLowerCase()));
        // clears query of automplete if no INDRA_printAirportName is retrieved..
        if (this.INDRA_printAirportName.length == 0) {
            this.query = '';
        }
        this.hasFocus = true;
        this.showAutocomplete = true;
    };
    INDRAAirportInputComponent.prototype.INDRA_handleInputBlur = function (e) {
        var _this = this;
        this.hasFocus = false;
        var dataOption = this.dataOptions ? this.dataOptions.find(function (optionItem) { return (optionItem.location.city + ', ' + optionItem.location.country) === _this.INDRA_printAirportName; }) : this.dataOptions;
        if (!dataOption && !this.airport) {
            // clears everything (except for query) if no valid airport was selected from autocomplete
            this.keyboardInput = '';
            var input = document.getElementById(this.id + '');
            if (input) {
                input.value = '';
            }
            this.selected.emit(null);
        }
        setTimeout(function () {
            if (!_this.hasFocus) {
                _this.showAutocomplete = false;
            }
        }, 300);
        if (this.airport instanceof Object) {
            this.propagateChange(this.airport);
        }
    };
    INDRAAirportInputComponent.prototype.INDRA_handleFocusedId = function (e) {
        this.autocompleteFocusedID = e;
    };
    INDRAAirportInputComponent.prototype.INDRA_handleSelect = function (e) {
        var _this = this;
        if (e !== null) {
            this.hasFocus = false;
            this.showAutocomplete = false;
        }
        if (e && e.type == 'recent-search') {
            var newSearchRoutes = Object.assign([], this.searchRoutes);
            if (this.searchRoutes.length >= this.currentSearch + 1) {
                newSearchRoutes = newSearchRoutes.map(function (cur, idx) {
                    if (idx === _this.currentSearch)
                        cur = e.value;
                    return cur;
                });
            }
            else {
                newSearchRoutes.push(e.value);
            }
            this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
            this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
        }
        else {
            this.writeValue(e);
            this.propagateChange(e);
        }
        if (e) {
            this.selected.emit(e);
        }
    };
    INDRAAirportInputComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    INDRAAirportInputComponent.prototype.registerOnTouched = function () { };
    INDRAAirportInputComponent.prototype.writeValue = function (value) {
        this.airport = value;
    };
    INDRAAirportInputComponent.prototype.INDRA_class = function () {
        var result = [];
        if (!!this.airport && this.airport.code !== undefined && !this.isLoading)
            result.push('filled');
        if (!!this.airport && this.airport.code === undefined) {
            this.airport = null;
        }
        if (this.hasFocus)
            result.push('focus');
        if (this.disabledForm)
            result.push('is-disabled');
        if (this.instruction)
            result.push('has-instruction');
        if (this.isLoading)
            result.push('is-loading');
        return result.join(' ');
    };
    return INDRAAirportInputComponent;
}(AirportInputComponent));
export { INDRAAirportInputComponent };
